import React from 'react';

//CORE COMPONENTS
import { ThemeProvider, styled } from '../../../components-core/packages/components-core/dist/theme-provider';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerVerticalAlignment,
    ContainerHorizontalAlignment,
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';

//STYLE
import { 
    Text, 
    TextAppearance, 
    TextAlignment,
} from '../../../components-core/packages/components-core/dist/text';
import { Link } from '../../../components-core/packages/components-core/dist/link'
import { Accordion } from '../../../components-core/packages/components-core/dist/accordion';

//CUSTOM COMPONENTS
import AccordionContentRows from '../price-list/inner-components/accordion-content-row/AccordionContentRow';



const Line = styled.div`
    background-color: #dfe4e8;
    width: 100%;
    height: 2px;
    display: ${props => props.isLast ? 'none' : 'block'};
`;

const TableContainer = styled.div`
    border: 1px solid;
    border-color: #dfe4e8;
    width: 100%;
`;



class PriceListOptionalAccrodion extends React.Component {

    constructor() {
        super();
        this.state = {
            isOpened: false,
        }
    }

    renderAccordion() {
        const { isOpened } = this.state;

        const lineContainerPadding = { 
            top: ContainerPadding.static200, 
            bottom: ContainerPadding.static200 
        }

        const renderedAccordion = [
            <Accordion
                id={'1'}
                headline={renderAccordionHeadline()}
                isOpen={isOpened}
                onClick={() => this.setState({ isOpened: !isOpened })}
            >
                <Container stretchContent={true} padding={lineContainerPadding}>
                    <Line isLast={false}/>
                </Container>
                <AccordionContentRows data={this.props.optional} accordionType={'optional'}/>
            </Accordion>,
        ]
        
        return (
            <Container 
                stretchContent={true} 
                padding={accordionContainerPadding} 
                wrap={ContainerWrap.always}
            >
                {renderedAccordion}
            </Container>
        )
    }

    render() {
        const containerPadding = { 
            top: ContainerPadding.dynamic0020, 
            bottom: ContainerPadding.dynamic0040
        }   

        return (
            <ThemeProvider>
                <Container stretchContent={true} padding={topContainerPadding}>
                    <TableContainer>
                        <Container 
                            stretchContent={true} 
                            padding={containerPadding}
                            wrap={ContainerWrap.always}
                        >
                            {this.renderAccordion()}
                        </Container>
                    </TableContainer>
                </Container>
            </ThemeProvider> 
        )
    }
}

/**
 * TODO @TugkanPilka: Fiyat rengini ayarla.
 */
const renderAccordionHeadline = () => (
    <Container verticalAlign={ContainerVerticalAlignment.center}>
        <Text appearance={TextAppearance.copy0200} bold>
            Opsiyonlar
        </Text>
    </Container>
)


const topContainerPadding = {
    left: { 
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b1600]: ContainerPadding.grid004
    }, 
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b1600]: ContainerPadding.grid004
    }
}

const accordionContainerPadding = {
    left: ContainerPadding.dynamic0140,
    right: ContainerPadding.dynamic0100,
}

const sampleList = {
    title: 'Caddy 2.0 TDI 102 PS Trendline',
    price: '12', 
    description: 'Kampanyalı anahtar teslim fiyatı',
    optionalDetails: [
        { 
            'title': 'Metalik Renk*',
            'description': '154.000 TL'
        },
    ]
}

export default PriceListOptionalAccrodion;